<template>
  <div class="material titles-material">
    <div class="nav clearfix navResize">
      <div class="clearfix">
        <ul class="options">
          <li
            :class="[{ active: active_idx_options == 0 }, 'title']"
            @click="activeFn('active_idx_options', 0, '标题')">
            <el-dropdown trigger="hover">
              <span class="el-dropdown-link" :class="[{ active: active_idx_options == 0 }, 'title']">
                标题
              </span>
              <el-dropdown-menu v-show="dropdown_data_title[active_idx_options]" class="title-dropdown-info-menu" slot="dropdown">
                <el-dropdown-item 
                 v-for="(val, idx) in dropdown_data_title[active_idx_options]"
                 :key="idx"
                 :class="{ activeColor: active_keys_idx == idx }">
                <span
                  style="padding-left:18px"
                  @click="active_key_fn(idx, val)">{{ val }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li
            :class="{ active: active_idx_options == 1 }"
            @click="activeFn('active_idx_options', 1, '正文')"
          >正文</li>
          <li
            :class="{ active: active_idx_options == 2 }"
            @click="activeFn('active_idx_options', 2, '图文')"
          >图文</li>
          <li
            :class="{ active: active_idx_options == 3 }"
            @click="activeFn('active_idx_options', 3, '引导')"
          >引导</li>
          <li
            :class="{ active: active_idx_options == 5 }"
            @click="activeFn('active_idx_options', 5, '风格')"
          >风格</li>
          <li
            :class="{ active: active_idx_options == 6 }"
            @click="activeFn('active_idx_options', 6, '节日')"
          >节日</li>
          <li
            :class="{ active: active_idx_options == 7 }"
            @click="activeFn('active_idx_options', 7, '行业')"
          >行业</li>
        </ul>
      </div>
      <div class="other">
        <div class="search-input">
          <input
            type="text"
            class="searchBox"
            v-model="search_value"
            placeholder="输入关键字"
            @keyup.enter="submitFn" />
          <i class="cus-icon icon14"></i>
        </div>
        <ul class="ul-list hot-new-list">
          <li @click="changeTab(index, item)" :class="activeClass == index ? 'active' : ''" v-for="(item, index) in liList">{{item}}</li>
        </ul>
      </div>
      <div class="edit-title-info">
        <el-radio-group v-model="searchInfo" @change="changeSelect">
          <el-radio-button :label="'all'">全部</el-radio-button>
          <el-radio-button :label="'fav'">收藏</el-radio-button>
        </el-radio-group>
        <ul class="ul-list">
          <li @click="changeTabHot(index, item.id)" :class="activeClassHot == index ? 'active' : ''" v-for="(item, index) in groupList">
            <i :class="item.icon"></i>
            <span>{{item.name}}</span> 
          </li>
        </ul>
      </div>
    </div>
    <div class="prompt" v-show="prompt_show">{{ prompt_value }}</div>
    <div :class="[{cursor_load:state_load},'list_box resultResize']">
      <ul class="list_content">
        <li
          v-for="(item, key) in itemSet"
          :key="key"
          :class="{cursor_load:state_load}"
          @click="msg_click(item)">
          <div class="content-html" v-html="item.content"></div>
            <div class="only-txt" v-if="item.is_favorite === 0">
              <el-popover
                popper-class="opreate-popover"
                placement="top-start"
                trigger="hover"
                content="收藏">
                <el-button @click="styleCollect(item.id)" slot="reference" type="text" class="el-icon-star-off level-btn"></el-button>
              </el-popover>
            </div>
            <div class="only-txt" v-else>
              <el-popover
                popper-class="opreate-popover"
                placement="top-start"
                trigger="hover"
                content="取消收藏">
                <el-button @click="styleCancel(item.id)" slot="reference" type="text" class="el-icon-star-on level-btn"></el-button>
              </el-popover>
            </div>
          </li>
        <li
          class="load"
          :style="show_load"
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="busy"
          infinite-scroll-distance="0">
          <!-- <i class="el-icon-loading"></i> -->
        </li>
        <li class="over_moudle" v-show="waterfall_over">
          <div>已经到底了：）！</div>
        </li>
      </ul>
      <div v-show="nav_load" class="nav_load">
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </div>
</template>

<script>
import StyleService from '@/service/api/styleService'
import comDropdown from "./com-dropdown.vue";

export default {
  name: "comMaterial",
  data() {
    return {
      params: {
        tag: "标题",
        page: 0,
        order: 'rec',
        type: 'all',
      },
      page: 1,
      total: 1,
      searchInfo: 'all',
      activeClass: 0,
      activeClassHot: 0,
      waterfall_over: 0,
      busy: false,
      nav_load: 1,
      state_load: 0,
      search_value: "",
      active_keys_idx: 0,
      prompt_value: "搜索 “元宵节” 的结果：",
      prompt_show: false,
      active_idx_options: 0,
      dropdown_data_title: [
        ["全部", "编号标题", "线框标题", "底色标题", "图片标题"],
        ["全部", "边框", "底色内容", "对话", "表格", "引用", "轴线", "竖排"],
        [
          "全部",
          "上下图文",
          "左右图文",
          "背景图文",
          "单图",
          "双图",
          "三图",
          "三图以上"
        ],
        [
          "全部",
          "关注",
          "标星",
          "好看",
          "点赞",
          "阅读原文",
          "往期回顾",
          "二维码"
        ],
        ["全部", "分割线", "视频", "音频", "按钮"],
        ["全部", "简约", "怀旧", "时尚", "卡通", "古典", "商务"],
        [
          "全部",
          "元旦",
          "春节",
          "元宵节",
          "情人节",
          "妇女节",
          "植树节",
          "愚人节",
          "清明节",
          "劳动节",
          "青年节",
          "母亲节",
          "端午节",
          "儿童节",
          "父亲节",
          "建军节",
          "七夕节",
          "教师节",
          "中秋节",
          "国庆节",
          "重阳节",
          "万圣节",
          "感恩节",
          "圣诞节",
          "腊八节",
          "春天",
          "夏天",
          "秋天",
          "冬天",
          "二十四节气",
          "购物节"
        ],
        [
          "全部",
          "电商",
          "教育",
          "房产",
          "旅游",
          "医疗",
          "汽车",
          "婚庆",
          "家居",
          "餐饮",
          "母婴",
          "金融",
          "互联网",
          "广告传媒",
          "其他"
        ]
      ],
      active_idx_sort: 0,
      show_load: "visibility:visible",
      itemSet: [],
      liList: ['招聘', '清明', '五一', '花纹', '日式'],
      groupList: [{
        name: '推荐',
        icon: 'iconfont icon-tuijian',
        id: 'rec'
      }, {
        name: '最热',
        icon: 'iconfont icon-zuire',
        id: 'hot'
      }, {
        name: '最新',
        icon: 'iconfont icon-zuixin',
        id: 'new'
      }]
    };
  },
  methods: {
    //切换nav
    activeFn(name, idx, tag) {
      this[name] = idx;
      this.active_keys_idx = 0;
      this.params.page = 1;
      this.params.tag = tag;
      this.search_value = "";
      this.changData();
    },
    changeTabHot (indx, id) {
      this.activeClassHot = indx
      this.params.order = id
      this.changData()
    },
    changeSelect() {
      this.params.type = this.searchInfo
      this.changData()
    },
    changeTab (val, indx) {
      this.activeClass = indx
      this.params.tag = val
      this.changData()
    },
    //切换数据，数据节流加载
    changData() {
      this.nav_load = 1;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        document.querySelector(".list_box").scrollTop = 0;
        this.getData();
      }, 500);
    },
    //切换key
    active_key_fn(idx, tag) {
      this.active_keys_idx = idx;
      this.search_value = "";
      this.params.page = 1;
      this.params.tag = tag;
      this.changData();
    },
    styleCollect (id) {
      const styleSystem = new StyleService()
      styleSystem.addStyle({sid: id})
        .then(() => {
          this.$notify.success('收藏成功')
          this.changData()
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    styleCancel (id) {
      const styleSystem = new StyleService()
      styleSystem.cancelStyle({sid: id})
        .then(() => {
          this.$notify.success('已取消收藏')
          this.changData()
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    //获取数据
    getData(type) {
      this.prompt_show = false;
      this.waterfall_over = 0;
      const styleSystem = new StyleService()
      styleSystem.styleList(this.params)
        .then(({ data }) => {
          if (data.data && data.data.length != 0) {
            if (type) {
              this.itemSet = [
                ...this.itemSet,
                ...data.data
              ]
            } else {
              this.itemSet = data.data;
            }
          } else if (this.params.page == 1) {
            this.prompt_show = true;
            this.itemSet = [];
            this.prompt_value = `很抱歉，没有找到 “${this.params.tag}” 相关的结果：`;
          }
          if (!data.data || data.data.length < 20) {
            this.waterfall_over = 1;
          } else {
            this.busy = false;
          }
          this.nav_load = 0;
          this.state_load = 0;
          this.show_load = "visibility:hidden";
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    //下拉加载
    loadMore() {
      if (this.busy) return;
      this.show_load = "visibility:visible";
      this.busy = true;
      this.state_load = 1;
      setTimeout(() => {
        this.params.page++;
        this.getData(1);
      }, 1000);
    },
    //item点击
    msg_click(data) {
      data.types = 'style'
      this.$emit("add_ueditor_value", data);
    },
    //站内搜索
    submitFn() {
      this.params.page = 1;
      this.params.tag = this.search_value;
      this.changData();
    },
    //点击下拉nav
    choose_title_fn(msg) {
      this.params.page = 1;
      this.params.tag = msg;
      this.search_value = "";
      this.getData();
    }
  },
  components: {
    comDropdown
  }
};
</script>

<style>
.ihuyiEditor {
  width: 100%;
}
</style>

<style lang="scss" scoped>
@import '../assets/icon-font/iconfont.css';

.material {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  color: #535353;
  position: relative;
  // overflow: hidden;
  .activeColor{
    color: $color;
  }
  .clearfix {
    zoom: 1;
    &::after {
      content: "";
      height: 0;
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
    }
  }

  .options {
    min-width: 385px;
    position: relative;
    width: 100%;
    height: 50px;
    display: flex;
    float: left;
    font-size: 14px;
    // justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    li {
      cursor: pointer;
      line-height: 48px;
      padding: 0 12px;
      border-bottom: 2px solid transparent;
      background: #ebebeb;
      margin-right: 2px;
      &:last-child{
        margin-right: 0;
        padding-right: 21px;
      }
      &:hover {
        color: $color;
        border-bottom: 2px solid $color;
      }

      position: relative;
      .dropdown {
        position: absolute;
        left: 0;
        top: 105%;
        display: none;
        z-index: 10;
        max-height: 500px;
        overflow-y: scroll;
      }
      &:hover .dropdown {
        display: block;
      }
      &:last-child .dropdown {
        right: 0;
        left: auto;
      }
    }
  }
  .other {
    width: 98%;
    height: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 0 16px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    z-index: 1000;
    background: #fff;
    .ul-list{
      display: flex;
      align-items: center;
      .active{
        color: #ffb13a;
      }
      li{
        font-size: 14px;
        margin-right: 8px;
        cursor: pointer;
        border-bottom: solid 2px #fff;
      }
    }
    .hot-new-list{
      li{
        &:first-child{
          color: #ffb13a;
        }
        &:first-child:hover{
          color: #ffb13a;
        }
        &:hover{
          border-color: #67c23a;
          color: #67c23a;
        }
      }
    }
  }
  .edit-title-info{
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    z-index: 1000;
    background: #fff;
    position: relative;
    width: 92%;
    .ul-list{
      display: flex;
      font-size: 14px;
      .active{
        color: #67c23a;
        font-weight: normal;
      }
      li{
        margin-right: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        i{
          margin-right: 5px;
        }
        &:hover{
          color: #67c23a;
        }
      }
    }
  }
  .keyWords {
    font-size: 14px;
    min-width: 385px;
    box-sizing: border-box;
    line-height: 27px;
    width: 100%;
    padding: 10px 16px;
    line-height: 25px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    span {
      margin-right: 15px;
      display: inline-block;
      cursor: pointer;
      &:hover {
        color: $color;
      }
    }
  }
  .active {
    color: $color;
    font-weight: bold;
    background: #fff !important;
  }
  .active_sort {
    color: #ffb13a;
  }
  .sort {
    font-size: 14px;
    display: flex;
    float: left;
    align-items: center;
    justify-content: space-between;

    li {
      margin-left: 10px;
      display: flex;
      float: left;
      align-items: center;

      i {
        margin-right: 2px;
        display: inline-block;
      }
    }
  }
  .searchBox {
    background-color: #f0f0f0;
    color: #a9aba8;
    font-size: 12px;
    border-radius: 15px;
    line-height: 25px;
    height: 25px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 30px 0 15px;
    width: 150px;
    border: none;

    &:hover + .icon14 {
      @extend .icon14_;
    }
  }
  .prompt {
    width: 330px;
    margin: auto;
    line-height: 40px;
    font-size: 13px;
    text-align: center;
    margin-top: 15px;
    background-color: rgba(204, 204, 204, 1);
  }

  .list_box {
    width: 100%;
    position: absolute;
    top: 100px;
    bottom: 0;
    overflow-y: scroll;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }

  .list_content {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    float: left;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 100%;
    align-content: flex-start;
    padding: 10px 15px;
    margin-top: 46px;

    // &::-webkit-scrollbar {
    //   display: none;
    // }

    li {
      cursor: pointer;
      width: 355px;
      // margin: 15px;
      max-width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 0;
      background-color: #fff;
      overflow: hidden;
      box-sizing: border-box;
      border: 1px dotted #d9d9d9;
      position: relative;
      .only-txt{
        position: absolute;
        z-index: 900;
        right: 0;
        top: -4px;
        .level-btn{
          font-size: 18px;
          color: #ffb13a;
        }
      }
      &:hover {
        border: 1px solid $color;
      }

      section {
        max-width: 100%;
      }
    }
  }

  .icon14 {
    position: absolute;
    top: 16px;
    left: 140px;
  }

  .icon_box {
    display: inline-flex;
    align-items: center;
  }
  .icon15,
  .icon15_ {
    margin-left: 5px;
  }
  .list_content li.load {
    position: relative;
    width: 100%;
    display: flex;
    float: left;
    // height: 15px;
    margin: 0;
    justify-content: center;
    border: none;
    &:hover {
      border: none;
    }
    .el-icon-loading {
      position: absolute;
    }
  }
}

.bm_0 .list_content li {
  max-width: 100% !important;
}
.bm_1 .list_content li {
  max-width: 49%;
}
</style>



// WEBPACK FOOTER //
// src/components/com-material.vue